import { getRecommendedXtimeServices, getXtimeServices } from '../../../API/GoMoto';

const currentYear = new Date()
    .getUTCFullYear();

function estimateMileageOnYear(year: number) {
    // National average of miles driven applied over each year
    return (currentYear - year) * 13476;
}

export class Xtime {
    private _kioskKey: string;
    private _dealerKey: string;

    constructor(kioskKey: string, dealerKey: string) {
        this._kioskKey = kioskKey;
        this._dealerKey = dealerKey;
    }

    async getRecommendedServices(vin: string, year: number | string, make: string, mileage?: number) {
        if (!mileage) {
            mileage = estimateMileageOnYear(typeof year === 'string' ? parseInt(year, 10) : year);
        }

        const returnedPayload = await getRecommendedXtimeServices(this._kioskKey, this._dealerKey, make, mileage, vin);

        return returnedPayload || undefined;
    }

    async getServices(vin: string, make: string) {
        return await getXtimeServices(this._kioskKey, this._dealerKey, make, vin);
    }

    compareNamesWith = (name1: string, name2: string, comparator: string) => {
        const splitCompare = comparator
            .replace('(', '')
            .replace(')', '')
            .split(' ')
            .map((word) => word.toLowerCase());
        const name1CommonScoreWords = name1
            .replace('(', '')
            .replace(')', '')
            .split(' ')
            .filter((word) => splitCompare.indexOf(word.toLowerCase()) > -1);
        const name2CommonScoreWords = name2
            .replace('(', '')
            .replace(')', '')
            .split(' ')
            .filter((word) => splitCompare.indexOf(word.toLowerCase()) > -1);

        console.debug(
            `
      name1: ${name1}
      name2: ${name2}
      comparator: ${comparator}
      name1 score: ${name1CommonScoreWords}
      name2 score: ${name2CommonScoreWords}
    `,
        );

        // Reverse the subtraction to make sure larger scores sort higher
        return name2CommonScoreWords.length - name1CommonScoreWords.length;
    };
}
